<template>
    <div id="`exemptionlist`">
        <app-gridview 
            v-bind:parentData = "{
                tabHeaders: this.dataHeader,
                tabItems: this.dataItems,
                pageTitle: this.pageTitle,
                search: this.search,
            }"
            v-on:EditItem="editItemHandler($event)"
            v-on:DeleteItem="deleteItemHandler($event)"
            v-on:NewPressed="newRecordHandler"
        >
          <template v-slot:[`item.exemptionamount`]="{ item }">
            {{ item.exemptionamount ? Number(item.exemptionamount).toLocaleString('en-MY', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '' }}
          </template>
        </app-gridview>
    </div>
</template>

<script>
import moment from 'moment';

import GridView from '../../../components/common/GridView';

export default {
    components: {
        'app-gridview': GridView
    },

    data() {
        return {
            pageTitle: this.$t('setuptaxableexemption.taxableexemptionlist'),
            dataHeader: [
                { text: this.$t('columns.actions'),           value: 'action',            sortable: false,width:'80px'},
                { text: this.$t('setuptaxableexemption.exemption'),   value: 'exemptioncode',     width: '150px'},
                { text: this.$t('columns.description'),   value: 'exemptiondesc',     width: '400px' },
                { text: this.$t('columns.startdate'),       value: 'startdate',         width: '130px' },
                { text: this.$t('columns.enddate'),         value: 'enddate',           width: '130px' },
                { text: this.$t('setuptaxableexemption.exemptionamount'), value: 'exemptionamount',   width: '110px' },
                { text: this.$t('columns.currency'),         value: 'crcycode',          width: '120px' },
                { text: this.$t('columns.remark'),           value: 'remark',            width: '100px' },
            ],

            dataItems: [],
            loading: false,
            errMsg: '',
             search: this.$route.params.search,
        }
    },

    methods: {
        getExemptionListHandler() {
            const vm = this;

            this.loading = !this.loading;

            this.$store.dispatch('get', {url: '/taxexemptiondt/all'})
                .then(function (res) {
                    vm.dataItems = res.data.rec;

                    for (let i = 0; i < vm.dataItems.length; i++) {
                        if (vm.dataItems[i].startdate) {
                            vm.dataItems[i].startdate = moment(vm.dataItems[i].startdate).format('YYYY-MM-DD');
                        }

                        if (vm.dataItems[i].enddate) {
                            vm.dataItems[i].enddate = moment(vm.dataItems[i].enddate).format('YYYY-MM-DD');
                        }
                    }

                    vm.loading = !vm.loading;
                })
                .catch(function (err) {
                    vm.errMsg = err;
                });

        },

        editItemHandler(item) {
            this.$router.push({name: 'exemptionedit', params: { id: item.id, search: item.search } });
        },

        newRecordHandler() {
            this.$router.push({name: 'exemptionnew'});
        }
    },

    mounted() {
        this.getExemptionListHandler();
    }
}
</script>